<style lang="scss">
img {
  vertical-align: middle;
  height: 16px;
}
.logistics-title {
  line-height: 36px;
  border-bottom: 1px solid #dedede;
  margin-bottom: 16px;
  padding-left: 20px;
  background-color: #2db7f5;
  color: #fff;
}
</style>

<template>
  <div class="bg-fff shadow margin-top-20">
    <header class="logistics-title font-bold">仓库物流信息</header>
    <Alert v-show="comLogistics.isChannelPay==1"
           class="margin-left-20 margin-right-20 font-bold"
           type="error">小贴士：本订单运费由平台支付，请使用Third Party来打印面单！</Alert>
    <Form :label-width="120"
          :model="formData"
          class="margin-15 clearfix">
      <Col span="24">
      <Col span="12"
           style="height:32px;">
      <FormItem label='发货仓库'
                v-if="alltype == 'query'">
        <span class="font-weight">{{getOrgWarehouseAll(comLogistics.orgWarehouseId)}}</span>

      </FormItem>
      <FormItem v-else
                label='发货仓库'
                :rules="required"
                prop="orgWarehouseCode">
        <Select v-model="formData.orgWarehouseCode"
                filterable
                clearable
                @on-change="getShipping">
          <Option value="0">System Auto</Option>
          <Option v-for="item in orgWarehouseAll"
                  :value="item.attach.code"
                  :key="item.value">{{ item.label}}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label='发货服务等级'>
        <span class="font-weight">{{comLogistics.shipServiceLevel}}</span>
      </FormItem>
      </Col>
      <Col span="12"
           style="height:32px;">
      <FormItem label='发货方式'
                v-if="alltype == 'query'">
        <span class="font-weight">{{comLogistics.shippingMethodCode}}</span>

      </FormItem>
      <FormItem v-else
                label='发货方式'
                :rules="required"
                prop="shippingMethodCode">
        <Select v-model="formData.shippingMethodCode"
                filterable
                clearable
                ref="refshipping"
                :loading="loading">
          <Option value="AUTO">System Auto</Option>
          <Option v-for="item in shippingList"
                  :value="item.carrierServiceCode"
                  :key="item.carrierServiceCode">{{ item.carrierServiceCode }}</Option>
        </Select>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label='最晚发货时间'>
        <span class="font-weight">{{comLogistics.latestShipDate}}</span>
      </FormItem>
      </Col>
      <Col span="12"
           style="height:32px;">
      <FormItem label='3rd账号'
                v-if="alltype == 'query'">
        <span class="font-weight margin-right-10">{{comLogistics.chargeAccountNo}}</span>
        <!-- <Tooltip v-show="comLogistics.isChannelPay==1" content="平台支付运费" placement="top">
                            <Icon type="card" style="vertical-align: sub;" class="font-20"></Icon>
                        </Tooltip> -->
      </FormItem>
      <FormItem v-else
                label='3rd账号'>
        <Input v-model="formData.chargeAccountNo"></Input>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label='渠道发货方式'>
        <span class="font-weight">{{comLogistics.channelMethodCode}}</span>
      </FormItem>
      </Col>
      <Col span="12"
           style="height:32px;">
      <FormItem v-if="alltype == 'query'"
                label='是否投保'>
        <span class="font-weight">{{comLogistics.isInsurance == 'Y' ? '是' : '否'}}</span>
      </FormItem>
      <FormItem v-else
                label='是否投保'>
        <div>
          <RadioGroup v-model="comLogistics.isInsurance">
            <Radio label="Y">
              <Icon type="social-yes"></Icon>
              <span>是</span>
            </Radio>
            <Radio label="N">
              <Icon type="social-no"></Icon>
              <span>否</span>
            </Radio>
          </RadioGroup>
        </div>
      </FormItem>
      </Col>
      <Col span="12">
      <FormItem label='渠道仓库'>
        <span class="font-weight">{{comLogistics.channelWarehouseCode}} </span>
      </FormItem>
      </Col>
      <Col span="12"
           style="height:32px;">
      <FormItem v-if="alltype == 'query'"
                label='是否需要签收'>
        <span class="font-weight">{{comLogistics.isSign == '1' ? '是' : '否'}}</span>
      </FormItem>
      <FormItem v-else
                label='是否需要签收'>
        <div>
          <RadioGroup v-model="comLogistics.isSign">
            <Radio label="1">
              <Icon type="social-yes"></Icon>
              <span>是</span>
            </Radio>
            <Radio label="0">
              <Icon type="social-no"></Icon>
              <span>否</span>
            </Radio>
          </RadioGroup>
        </div>
      </FormItem>
      </Col>
      <Col span="12"
           v-if=" alltype =='query'">
      <FormItem label='产品重量'>
        <span class="font-weight">{{comLogistics.weight}} g / {{(comLogistics.weight * 0.035274).toFixed(2)}} oz </span>
      </FormItem>
      </Col>
      <Col span="12"
           v-if=" alltype =='query'">
      <FormItem label='预估物流费'>
        <span class="font-weight">{{comLogistics.shippingfee}} USD</span>
      </FormItem>
      </Col>
      </Col>
    </Form>
  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'
import { HttpProductErpSku } from '@/service/boss/dictionary'
import { HttpFindWarehouseCarriers } from '@/service/boss/b2corder'
export default {
  props: ['comLogistics', 'alltype', 'status', 'parentId', 'orderOrgId'],
  data () {
    return {
      formData: {
        orgWarehouseCode: "0",
        shippingMethodCode: "AUTO",
        chargeAccountNo: '',
        isInsurance: 'N',
        isSign: '',
        // warehouseId:'0',
      },
      loading: false,
      shippingList: [],
      required: [{
        required: true,
        message: "该信息不能为空,请填写"
      }],
    }
  },
  created () {
    if (this.alltype != 'query') {
      this.handleDatas()
    }
  },
  computed: {
    ...mapState('boss', ['productLineAll']),
    ...mapGetters('dictionary', ['getNewAllWarehouseIdList']),
    orgWarehouseAll () {
      let _this = this
      // console.log(this.orderOrgId)
      return this.getNewAllWarehouseIdList.filter(function (item) {
        return item.attach.warehouseType != 4 && item.attach.orgId == _this.orderOrgId
      })
    },

  },
  methods: {
    getOrgWarehouseAll (id) {
      let jsonone = this.getNewAllWarehouseIdList.filter(item => {
        return item.value == id
      })[0] || {}
      return jsonone.label
    },
    handleDatas () {
      if (this.comLogistics.orgWarehouseCode) {
        let { orgWarehouseCode, shippingMethodCode, chargeAccountNo, isInsurance } = this.comLogistics
        this.formData = { orgWarehouseCode, shippingMethodCode, chargeAccountNo, isInsurance }
        if (this.formData.shippingMethodCode == '') {
          this.formData.shippingMethodCode = "AUTO"
        }
        else {
          let json = { carrierServiceCode: shippingMethodCode }
          this.shippingList.push(json)
          this.formData.shippingMethodCode = shippingMethodCode
          this.loading = true;
        }
        this.getwarehouseCarry(this.formData.orgWarehouseCode)
      } else {
        let { orgWarehouseCode, shippingMethodCode, chargeAccountNo, isInsurance } = this.comLogistics
        this.formData = { chargeAccountNo, isInsurance, isSign }
        this.formData.orgWarehouseCode = "0"
        /*this.formData.orgWarehouseCode = "0"
        this.formData.chargeAccountNo = ''
        this.formData.isInsurance = 'N'*/
        if (shippingMethodCode) {
          let aaa = [
            { carrierServiceCode: shippingMethodCode },
            { carrierServiceCode: 'WLC' },
            { carrierServiceCode: 'YRC' },
            { carrierServiceCode: 'Australia Post' },
            { carrierServiceCode: 'Other' }
          ]
          this.shippingList = aaa
          this.formData.shippingMethodCode = shippingMethodCode
        } else {
          this.formData.shippingMethodCode = "AUTO"
        }
      }
    },
    // 数组去重
    arrayUnique (arr, name) {
      var hash = {};
      return arr.reduce((item, next) => {
        hash[next[name]] ? '' : hash[next[name]] = true && item.push(next);
        return item;
      }, []);
    },
    getShipping () {
      // console.log(this.formData.orgWarehouseCode)
      this.formData.shippingMethodCode = ''
      this.$refs.refshipping.clearSingleSelect()
      this.loading = true
      if (this.formData.orgWarehouseCode != "0") {
        this.getwarehouseCarry(this.formData.orgWarehouseCode)
      } else {
        let aaa = [
          { carrierServiceCode: 'WLC' },
          { carrierServiceCode: 'YRC' },
          { carrierServiceCode: 'Australia Post' },
          { carrierServiceCode: 'Other' }
        ]
        this.loading = false
        this.shippingList = aaa
      }
    },
    getwarehouseCarry (value) {
      HttpFindWarehouseCarriers({
        warehouseCode: value,
        contextId: this.orderOrgId,
        orderType: 200
      }).then(res => {
        let aaa = [
          { carrierServiceCode: 'WLC' },
          { carrierServiceCode: 'YRC' },
          { carrierServiceCode: 'Australia Post' },
          { carrierServiceCode: 'Other' }
        ]
        this.shippingList = res.data
        this.shippingList = this.shippingList.concat(aaa)
        this.shippingList = this.arrayUnique(this.shippingList, 'carrierServiceCode')
        // console.log(res)
      }, err => {
        this.$VMessage.error({
          content: err.message,
          duration: 30,
          closable: true
        });
      }).finally(result => {
        this.loading = false
      })
    }
  },
  watch: {
    "comLogistics.isInsurance": function () {
      this.formData.isInsurance = this.comLogistics.isInsurance
    },
    "comLogistics.isSign": function () {
      this.formData.isSign = this.comLogistics.isSign
    },
    comLogistics () {
      if (this.alltype != 'query') {
        this.handleDatas()
      }
    }
  },

}
</script>

